import * as React from 'react'
import dayjs, { Dayjs } from 'dayjs'
import Button from '@mui/material/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import Form from 'react-bootstrap/Form'
import { AsyncPaginate } from "react-select-async-paginate";
import SearchIcon from '@mui/icons-material/Search'
import InputGroup from 'react-bootstrap/InputGroup'
import { useState } from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useDispatch, useSelector } from 'react-redux'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast } from '../../constants/toaster'

export const NormalUserFilters = (props) => {
  const userData = useSelector((state) => state?.userData);
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const pageNumberRef = React.useRef(pagerecord.pageNumber)
  const { setFilterData, filterData } = props
  const dispatch = useDispatch()
  const [value, setValue] = useState(dayjs())
  const [valueDropdown, setValueDropdown] = useState(null);


  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(undefined);
      }, ms);
    });

  const wrappedLoadOptions = React.useCallback(function (...args) {
    return loadOptionsTest(...args);
  }, []);

  const loadOptionsTest = async (
    search,
    prevOptions
  ) => {
    await sleep(1000);
    try {
      let postJson = {
        searchText: search?.trim(),
        pageNumber: search?.trim() ? 0 : pageNumberRef.current - 1,
        pageSize: pagerecord.pageSize || 10,
        shortingField: "createdAt",
        asc: false,
      }
      let path = urls.userSearchDropdownList
      let res = await ApiCaller.post(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        let tempArray = []
        response?.data?.items.forEach(element => {
          tempArray.push({
            value: element?.key,
            label: element?.value
          })
        });
        setPagerecord({
          ...pagerecord,
          pageNumber: pagerecord?.pageNumber + 1
        })

        pageNumberRef.current=pageNumberRef.current+1;
        const hasMore = response?.data?.totalPages > 0 && response?.data?.totalPages > pagerecord?.pageNumber;
        return {
          options: tempArray,
          hasMore
        };

      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    }

  };

  return (
    <div className='card-header border-0'>
      <div className='row align-items-end text-left g-3' style={{ paddingBottom: '15px' }}>
        <div className='col-md-3'>
          <div className="form-group mb-0">
            <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
              <i className="fas fa-search mr-1"></i>Search Users
            </label>
            <AsyncPaginate
              debounceTimeout={300}
              value={valueDropdown}
              loadOptions={(args) => wrappedLoadOptions(args,pagerecord)}
              onChange={(e) => {
                setValueDropdown(e)
                setFilterData((pre) => ({ ...pre, searchText: e?.label }))
              }}
            />
          </div>
        </div>
        <div className='col-md-2'>
          <div className="form-group mb-0">
            <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
              <i className="fas fa-filter mr-1"></i>Account Status
            </label>
            <Dropdown className='w-100'>
              <Dropdown.Toggle
                variant='outline-secondary'
                id='dropdown-basic'
                className='w-100 text-left'
                style={{
                  height: '38px', 
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  border: '1px solid #dee2e6',
                  backgroundColor: '#fff'
                }}
              >
                {filterData?.accountStatus || 'Select Status'}
              </Dropdown.Toggle>
              <Dropdown.Menu className='w-100'>
                <Dropdown.Item
                  onClick={() => setFilterData((pre) => ({ ...pre, accountStatus: 'Select Status' }))}
                >
                  Select Status
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setFilterData((pre) => ({ ...pre, accountStatus: 'Active' }))}>
                  Active
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setFilterData((pre) => ({ ...pre, accountStatus: 'In Active' }))}>
                  In Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className='col-md-3'>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-0">
                <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                  <i className="fas fa-calendar-alt mr-1"></i>From Date
                </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disableFuture
                    value={filterData?.startDate}
                    onChange={newValue => setFilterData((pre) => ({ ...pre, startDate: newValue }))}
                    maxDate={filterData?.endDate}
                    slotProps={{ 
                      textField: { 
                        size: 'small',
                        fullWidth: true,
                        variant: 'outlined',
                        placeholder: 'Select from date'
                      } 
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: '38px',
                        fontSize: '14px',
                        backgroundColor: '#fff',
                        border: '1px solid #dee2e6',
                        borderRadius: '0.375rem',
                        '&:hover': {
                          borderColor: '#86b7fe'
                        },
                        '&.Mui-focused': {
                          borderColor: '#86b7fe',
                          boxShadow: '0 0 0 0.2rem rgba(13, 110, 253, 0.25)'
                        }
                      },
                      '& .MuiInputLabel-root': {
                        display: 'none'
                      }
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-0">
                <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                  <i className="fas fa-calendar-alt mr-1"></i>To Date
                </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disableFuture
                    minDate={filterData?.startDate}
                    value={filterData?.endDate}
                    onChange={newValue => setFilterData((pre) => ({ ...pre, endDate: newValue }))}
                    slotProps={{ 
                      textField: { 
                        size: 'small',
                        fullWidth: true,
                        variant: 'outlined',
                        placeholder: 'Select to date'
                      } 
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: '38px',
                        fontSize: '14px',
                        backgroundColor: '#fff',
                        border: '1px solid #dee2e6',
                        borderRadius: '0.375rem',
                        '&:hover': {
                          borderColor: '#86b7fe'
                        },
                        '&.Mui-focused': {
                          borderColor: '#86b7fe',
                          boxShadow: '0 0 0 0.2rem rgba(13, 110, 253, 0.25)'
                        }
                      },
                      '& .MuiInputLabel-root': {
                        display: 'none'
                      }
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='col-md-1 mb-2 '>
          <Dropdown>
            <Dropdown.Toggle
              variant='success'
              style={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #cad1d7',
                boxShadow: 'none',
                transform: 'none'
              }}
              id='dropdown-basic'
            >
              {filterData?.subscription || 'Select Subscription'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => setFilterData((pre) => ({ ...pre, subscription: 'Select Subscription' }))}
              >
                Select Subscription
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => setFilterData((pre) => ({ ...pre, subscription: 'Subscription Name' }))}
              >
                Subscription Name
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div> */}
        <div className='col-md-3'>
          <div className="d-flex gap-2">
            <Button
              variant='contained'
              className='custom-filter-btn'
              onClick={() => props?.handleFilterClick()}
              style={{
                height: '38px',
                fontSize: '14px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="fas fa-search mr-2"></i>
              Filter
            </Button>
            <Button
              variant='outlined'
              className='custom-filter-btn'
              onClick={() => {
                props?.handleResetFilter()
                setValueDropdown(null)
              }}
              style={{
                height: '38px',
                fontSize: '14px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="fas fa-undo mr-2"></i>
              Reset
            </Button>
          </div>
        </div>
      </div>
    </div >
  )
}
